import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChangeLogDoc } from 'app/models/ChangeLogDoc';
import { ChangeLogKey } from 'app/models/ChangeLogKey';
import { ChangeLogMonth } from 'app/models/ChangeLogMonth';
import { AppChangelogService } from './app-changelog.service';

declare var jQuery;

@Component({
  selector: 'app-app-changelog',
  templateUrl: './app-changelog.component.html',
  styleUrls: ['./app-changelog.component.scss']
})
export class AppChangelogComponent implements OnChanges {
  @Input()
  changeLogData: Array<ChangeLogDoc>;

  @Input()
  region: string;

  @Input()
  isFreemium: boolean;

  @Input()
  isFollowing: boolean;

  @Input()
  locationLabel: string;

  @Input()
  locationDescription: string;

  changeLogKeys: Array<ChangeLogKey>;
  changeLogMonths: Array<ChangeLogMonth>;
  isAdvisory = true;
  isDeveloper = true;
  isRiskOverview = true;
  isSeller = true;
  isTraffic = true;
  isBrandSafety = true;
  isIvt = true;
  isInventory = true;

  constructor(private _changeLogService: AppChangelogService) {}

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      // console.log('PROP: ', propName);
      if (
        this.changeLogData &&
        (propName === 'changeLogData' || propName === 'isFollowing')
      ) {
        let toProcessChangeLog = JSON.parse(JSON.stringify(this.changeLogData));
        if (this.isFreemium && !this.isFollowing) {
          toProcessChangeLog = toProcessChangeLog.slice(0, 3);
        }
        void this._changeLogService
          .processChangeLogData(toProcessChangeLog)
          .then(response => {
            // console.log('processed: ', response);
            this.changeLogMonths = response.changeLogMonths;
          });
      }
    }
  }

  copyToCbLocation(location: any, event: any) {
    const item = `${location.oldVal} \n to \n ${location.latestVal}`;
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', item);
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
    jQuery(event.target).find('.copyClipboard').tooltip('show');
    setTimeout(() => {
      jQuery('.copyClipboard').tooltip('hide');
    }, 300);
  }
}
